





























































































































































































import Vue from 'vue';

export default Vue.extend({
  props: {
    masterSettingsObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saveType: 'allDraftAndFutureModels',
      textFieldRules: [
        (v) => v !== '' || 'Value is required',
        (v) => !isNaN(v) || 'Value can only be a number'
      ],
      categories: [
        {
          label: 'Government Taxation',
          expand: true,
          subcategories: [
            {
              label: 'Stamp Duty Rates',
              type: 'table',
              headers: ['Sales Price >', 'Lump Amount', 'Rate'],
              inputs: [
                [
                  {
                    name: 'stamp_duty_price1',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump1',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate1',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price2',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump2',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate2',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price3',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump3',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate3',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price4',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump4',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate4',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price5',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump5',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate5',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price6',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump6',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate6',
                    unit: '%'
                  }
                ],
                [
                  {
                    name: 'stamp_duty_price7',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_lump7',
                    unit: '$',
                    reverse: true
                  },
                  {
                    name: 'stamp_duty_rate7',
                    unit: '%'
                  }
                ]
              ]
            },
            {
              label: 'Land tax  (State Govt.)',
              inputs: [
                {
                  label: 'Minimum Threshold',
                  name: 'land_tax_min_thres',
                  unit: '$',
                  reverse: true
                },
                {
                  label: 'Rate',
                  name: 'land_tax_min_rate',
                  unit: '%'
                },
                {
                  label: 'Premium Threshold',
                  name: 'landtax_prem_thres',
                  unit: '$',
                  reverse: true
                },
                {
                  label: 'Rate',
                  name: 'land_tax_prem_rate',
                  unit: '%'
                }
              ]
            },
            {
              label: 'Goods & Services Tax (GST)',
              inputs: [
                {
                  label: 'Goods & Services Tax (GST)',
                  name: 'gst_amount',
                  unit: '%'
                }
              ]
            }
          ]
        }
      ] as any
    };
  },
  computed: {
    masterSettings(): any {
      if (
        this.masterSettingsObject &&
        this.masterSettingsObject.masterSettings
      ) {
        return this.masterSettingsObject.masterSettings;
      } else {
        return null;
      }
    },
    readOnly(): any {
      if (this.masterSettingsObject) {
        return this.masterSettingsObject.readOnly;
      } else {
        return true;
      }
    },
    updateMasterSettingsIsLoading(): boolean {
      return this.$store.direct.state.Model.updateMasterSettingsIsLoading;
    }
  },
  methods: {
    updateMasterSettings(value: string, input: any) {
      if (this.readOnly) {
        return;
      }

      if (value === '') {
        console.log('empty string');
        return;
      }
      let formattedValue = value as any;

      // Value needs to be converted to a number
      formattedValue = Number(value);
      if (isNaN(formattedValue)) {
        return;
      }

      // Update store
      this.$store.direct.commit.Model.UPDATE_MASTER_SETTING({
        value: formattedValue,
        name: input.name
      });
    },
    saveAndCalculate() {
      if (this.readOnly) {
        return;
      }

      this.$store.direct.dispatch.Model.updateMasterSettings({
        saveType: this.saveType
      }).then(() => {
        this.closeModal();
      });
    },
    closeModal() {
      this.$store.direct.commit.Model.UPDATE_SHOW_MASTER_SETTINGS_MODAL(false);
      this.$store.direct.commit.Feasibility.UPDATE_SHOW_MASTER_SETTINGS_MODAL(
        false
      );
    }
  }
});
